const lastLoginWidget = require('airship/widgets/last-login-timestamp')
const lastLoginElements = document.querySelectorAll('[rel=last-login-date]')

if (lastLoginElements.length) {
  for (var i = 0; i < lastLoginElements.length; i++) {
    lastLoginWidget(lastLoginElements[i])
  }
}
